export default Object.freeze({
  Portrait: 0,
  Landscape: 1,
});
